var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('label',{attrs:{"for":_vm.identifier}},[_c('input',{attrs:{"id":_vm.identifier,"type":"checkbox","required":_vm.required},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_vm._v(_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }